import script from "./ActionMenuAlt.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionMenuAlt.vue?vue&type=script&lang=ts&setup=true"

import "./ActionMenuAlt.vue?vue&type=style&index=0&id=0c2f1c9b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2f1c9b"]])

export default __exports__